import { useEffect, useState } from "react";
import { Modal, Button, Text } from "@mantine/core";
import { IconDeviceMobile, IconMail } from "@tabler/icons";
import { useTranslation } from "next-i18next";
import { useColors } from "../../../../hooks/colors/useColors";

export function OnlinePopup() {
  const { t } = useTranslation("common");
  const { colors } = useColors();
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    setOpened(true);
  }, []);

  const close = () => {
    setOpened(false);
  };

  return (
    <Modal
      opened={opened}
      onClose={close}
      centered
      size="lg"
      withCloseButton
      title={
        <Text size="xl" fw={700} style={{ color: colors.secondary }}>
          {t("online-popup-title")}
        </Text>
      }
    >
      <div className="flex flex-col gap-4">
        <Text
          size="md"
          // @ts-ignore
          dangerouslySetInnerHTML={{ __html: t("online-popup-intro") }}
        />
        <a href="tel:928332634" className="flex items-center gap-2">
          <IconDeviceMobile color={colors.primary} size={30} />
          <div>
            <Text size="lg" fw={700}>
              +351 928 332 634
            </Text>
            <p className="!my-0">{t("call-local")}</p>
          </div>
        </a>
        <a
          href="mailto:geral@psiworks.pt"
          className="flex items-center gap-2"
        >
          <IconMail color={colors.primary} size={30} />
          geral@psiworks.pt
        </a>
        <div className="flex justify-end mt-2">
          <Button onClick={close} style={{ backgroundColor: colors.primary }}>
            {t("online-popup-close")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
